/* Pendo core (EU) */
declare global {
  interface Window {
    pendo?: any;
    __pendoLoaded?: boolean;
  }
}

export type PendoUser    = { id: string|number; email?: string; role?: string; env?: string };
export type PendoAccount = { id: string|number; name?: string; plan?: string };

export function loadPendoAgentEU(apiKey: string) {
  if (window.__pendoLoaded) return;
  window.__pendoLoaded = true;

  (function (apiKey: string) {
    (function (p: any, e: Document, n: string, o?: string) {
      o = o || 'pendo';
      p[o] = p[o] || {};
      p[o]._q = p[o]._q || [];
      const v = ['initialize','identify','updateOptions','pageLoad','track'];
      for (let i = 0; i < v.length; i++) {
        const m = v[i];
        p[o][m] = p[o][m] || function () {
          p[o]._q[m === 'initialize' ? 'unshift' : 'push']([
            m, ...Array.prototype.slice.call(arguments, 0),
          ]);
        };
      }
      const s = e.createElement(n) as HTMLScriptElement;
      s.async = true;
      s.src   = 'https://cdn.eu.pendo.io/agent/static/' + apiKey + '/pendo.js';
      const z = e.getElementsByTagName('script')[0] as HTMLScriptElement;
      z.parentNode!.insertBefore(s, z);
    })(window, document, 'script', 'pendo');
  })(apiKey);
}

/* Initialize once you know the user & account */
export function initializePendo(user: PendoUser, account: PendoAccount) {
  (window as any).pendo?.initialize?.({
    visitor: { id: user.id, email: user.email, role: user.role, environment: user.env },
    account: { id: account.id, name: account.name, plan: account.plan },
  });
}

/* Convenience wrappers */
export function track(name: string, props: Record<string, any> = {}) {
  (window as any).pendo?.track?.(name, props);
}

export function pageLoad(name?: string, data: Record<string, any> = {}) {
  (window as any).pendo?.pageLoad?.({
    name: name || location.pathname + location.hash,
    url: location.pathname + location.search + location.hash,
    ...data,
  });
}

/* Hook SPA navigation so Pendo sees page views */
export function wireHistoryPageLoads() {
  const fire = (label: string) => setTimeout(() => pageLoad('Office:'+label), 0);

  const wrap = (type: 'pushState'|'replaceState') => {
    const orig = history[type];
    return function (this: History, ...args: any[]) {
      const ret = orig.apply(this, args as any);
      fire('Nav:'+type);
      return ret;
    };
  };
  history.pushState = wrap('pushState');
  history.replaceState = wrap('replaceState');
  window.addEventListener('popstate', () => fire('Nav:popstate'));
}

export function setupPendoForOffice(
  apiKey: string,
  getUser: () => PendoUser | null,
  getAccount: () => PendoAccount | null
) {
  loadPendoAgentEU(apiKey);

  // initialize when session is ready
  (function waitAndInit() {
    const u = getUser();
    const a = getAccount();
    if (u?.id && a?.id) {
      initializePendo(u, a);
      // SPA page views
      wireHistoryPageLoads();
      pageLoad('Office:Initial');
    } else {
      setTimeout(waitAndInit, 400);
    }
  })();
}
